import script from "./WoononVideoPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./WoononVideoPopup.vue?vue&type=script&lang=ts&setup=true"

import "./WoononVideoPopup.vue?vue&type=style&index=0&id=0e3d27e4&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e3d27e4"]])

export default __exports__